let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5A56H"), load("9tgTm"), load("aptN5"), load("4UPrd"), load("kXMKO")]).then(() => parcelRequire('QvxZa'));